<template>
    <div>
        <my-header></my-header>
         <div class="content clearfix">
             <div class="left">
                <ul>
                    <li @click="shoose(index)" :class="{actived:index==activedIndex}" v-for="(item,index) in tittle" :key="index">{{item.Name}}</li>
                </ul>
                
                <a href="https://fangte-1251510006.cos.ap-shanghai.myqcloud.com/TuKu/%E5%8D%8E%E5%BC%BA%E6%96%B9%E7%89%B9%E5%9B%BE%E5%BA%93%E7%BD%91-%E5%9B%BE%E5%BA%93%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E.pdf" title="右键另存为可下载文档" target="_blank" class="down-btn">查看使用帮助文档</a>
                <!--<p class="explain">注:右键另存为可下载文档</p>-->
             </div>
         <div class="right fr">
             <div class="con" v-if="detail">
                    <div class="same_module" v-for="(item,index) in list[activedIndex]" :key="index">
                            <div class="title header" :class="{up: index!=0}" @click="slide($event,index)"><h4>{{item.tittle}}<span></span></h4></div>
                            <div class="detail" :style="{height: index!=0 ? 0: ''}" >
                                    <ul class="inner item">
                                           <li v-for="(item1,index2) in item.content" :key="index2" >
                                                <span v-html="item1.item"></span>
                                                <img v-show="item1.src" :src="item1.src" alt="">
                                            </li>
                                    </ul>
                            </div>
                    </div>
            </div>
        
         </div>
             

         </div>
     
        <my-footer></my-footer>
    </div>
</template>
<script>
import img1 from "../../assets/img/help1.png"
import img2 from "../../assets/img/help2.png"
import img3 from "../../assets/img/help3.png"
import img4 from "../../assets/img/help4.png"
import img5 from "../../assets/img/help5.png"
import img6 from "../../assets/img/help6.png"
import img7 from "../../assets/img/help7.png"
import img8 from "../../assets/img/help8.png"
import img9 from "../../assets/img/help9.png"
import img10 from "../../assets/img/help10.png"

var tittle=[
    {Name:"菜单介绍"},
    {Name:"账户相关"},
    {Name:"搜索相关"},
    {Name:"版权相关"},
];
var list=[
            [ 
                {
                    "tittle":"1、集团VI",
                    "content":[
                        {"item":"（1）集团VI下载及使用说明。"},
                        {"item": "点击图片即可进入对应下载页面。集团VI下载页里面包括："},
                        {"item": "　A．使用文件（png）"},
                        {"item": "　B．使用规范文件（pdf）"},
                        {"item": "　C．输出文件（VI源文件）"},
                        {"item": "<span style='color: #ff0000'>企业VI是企业对外传递信息、诉讼公众形象的基本核心，在使用集团VI的时候，应严格按照使用规范文件里面的要求使用。</span>", "src": img1},
                        {"item": "（2）如何能找到集团VI？"},
                        {"item": "点击顶部菜单栏上的【公司资料】选择【集团VI】。", "src": img2},
                        
                    ]
                },
                {
                    "tittle":"2、版权图片",
                    "content":[
                        {"item": "（1）版权图片主要分为商业拍摄授权图片及已购买版权图片。"},
                        {"item": "　A．商业拍摄授权图片：公司拍摄及获得人物肖像使用授权，可用作商业用途的图片。"},
                        {"item": "　B．已购买版权图片：公司已购买版权，可用作商业用途的图片。"},
                        {"item": "（2）版权图片在哪里？"},
                        {"item": "点击顶部菜单栏上的【公司资料】选择【版权图片】。", "src": img3} 
                    ]
                },
                {
                    "tittle":"3、版权字体",
                    "content":[
                        {"item": "（1）版权字库主要分为授权字体及免费商用字体。"},
                        {"item": "　A．授权字体：公司购买相关版权，可用于商业用途的字体。"},
                        {"item": "　B．免费商用字体：可以直接免费下载使用，包括免费商业使用。"},
                        {"item": "<span style='color: #ff0000'>（公司的广告宣传画面，只能使用公司已购买版权的字体和免费商用字体，不得使用授权字体以外的字体！）</span>"},
                        {"item": "（2）哪里能找到版权字体？"},
                        {"item": "点击顶部菜单栏上的【公司资料】选择【版权字库】。", "src": img4}
                    ]
                },
                {
                        "tittle":"4、免版权素材",
                        "content":[
                            {"item": "（1）什么是免版权素材？"},
                            {"item": "是指免费无版权图片素材，即满足CC0协议，任何人免费下载图片用作任何用途。<span style='color: #ff0000'>请确保你上传的图片素材符合此要求！</span>（无版权图片网站说明所有作品授权CC0协议，表示作者已经放弃一切版权，作品可以被不加限制的引用、转载、二次改编、再发表、应用于商业用途，使用者可以不标示该创作的来源和作者）。"},
                            {"item": "（2）哪里能找到免版权素材？"},
                            {"item": "点击顶部菜单栏上的【创意图片】选择【免版权素材】。", "src": img5},
                        
                        ]
                },
                {
                        "tittle":"5、我要分享",
                        "content":[
                            {"item": "（1）我能上传哪些作品？"},
                            {"item": "　A．个人原创拍摄作品"},
                            {"item": "　B．公园拍摄作品"},
                            {"item": "　C．免费版权网站下载的无版权图片"},
                            {"item": "<span style='color: #ff0000'>（个人原创作品一经上传，则视为作者将其作品授权于华强方特，同意华强方特将作品用作商业用途）</span>"},
                            {"item": "（2）哪里能上传分享我的作品？"},
                            {"item": "点击顶部菜单栏上的【我要分享】", "src": img6},
                            {"item": "（3）如何上传？"},
                            {"item": "把需要上传的图片拖拽到上传页面，填写图片相关信息即可。"},
                            {"item": "<span style='color: #ff0000'>（用户在上传免版权素材时须在【素材来源】一栏填写获取该素材的网站链接）</span>"},
                            {"item": "图片/PPT素材上传后会展示在【创意图片】对应类目下，文章类素材上传后会展示在【设计交流】对应类目下。", "src": img7},
                        
                        ]
                },
                
            ],
            [ 
                {
                    "tittle":"1、如何登录图库网？",
                    "content":[
                        {"item":"首次登录请使用员工个人【秒通工号】和【秒通密码（默认为身份证后六位数）】进行登录。<span style='color: #ff0000'>（部分内容和功能需登录后方可使用）。</span>"},

                    ]
                },
                {
                    "tittle":"2、如何修改个人信息？",
                    "content":[
                        {"item":"通过右上角的头像进入【账号设置】可修改个人信息，目前仅支持个人昵称、头像和密码修改。","src":img8},
                       
                    ]
                },
              
            ],
            [ 
                {
                    "tittle":"1、如何搜索图片？",
                    "content":[
                        {"item":"网站首页的搜索框支持全局搜索<span style='color: #ff0000'>（部分内容需登录后才能查看）</span>。用户可通过下拉选择框选择“全部图片、集团VI、PPT、设计交流“进行分类搜索，输入想要搜索的关键字，即可得到相关图片。",
                        "src":img9
                        },
                        

                    ]
                },
                {
                    "tittle":"2、如何搜索某个分类里的图片？",
                    "content":[
                        {"item":"用户在进入某个分类之后，可通过顶部菜单的搜索栏进行该目录下的内容检索。例如进入【创意图片】下的【乐园专题图片】后使用顶部搜索功能，则搜索范围为【乐园专题图片】类目下的图片。",
                        "src":img10
                        },
                    ]
                },
              
            ],
           [ 
                {
                    "tittle":"1、商业用途图片和编辑用途图片的区别？",
                    "content":[
                        {"item":"商业用途图片：指被允许在商业/广告中使用。"},
                        {"item":"编辑用途图片：指被允许在新闻报道、出版发行、官方微博、微信等行为中使用，华强方特图库网及其供稿人仅拥有该图片的版权，不拥有画面内容中所涉及的任何人物的肖像权或实物的物权、知识产权等其它权利。该图片仅限编辑报道用途，禁止用于一切商业推广用途。"},
                        
                    ]
                },
                {
                    "tittle":"2、版权声明",
                    "content":[
                        {"item":"华强方特图库网根据用户指令提供作品上传、下载以及传播等内容，向来十分重视网络版权及其他知识产权以及用户权益的保护。"},
                        {"item": "华强方特图库网作为网络服务提供者，对非法转载，盗版行为的发生不具备充分监控能力，如果您认为用户通过华强方特图库网提供的信息或传播的内容侵犯了您的相关权益，您可向华强方特图库网所设立的专门接受版权投诉和侵权通知的邮箱发送相关电子邮件，我们将根据相关法律规定对违反规定的内容采取相应措施。"},
                    ]
                },
                {
                    "tittle":"3、上传声明",
                    "content":[
                        {"item":"华强方特图库网郑重提醒您:"},
                        {"item":"为响应国家九部委联合开展深入整治互联网和手机媒体淫秽色情及低俗信息专项行动的号召，营造一个健康文明的网络环境，给大家一个和谐积极的家园。"},
                        {"item": "1、不得上传任何有违国家法律法规的内容。"},
                        {"item": "2、不得上传具有色情以及有色情诱导性内容的内容。"},
                        {"item": "3、不得上传内容低俗，格调不高的内容。"},
                        {"item": "4、不得在标题、简介和标签中出现任何具有低俗色情含义的字眼。"},
                        {"item": "5、不得上传其他网站的精选版权作品。"},
                        {"item": "如果您上传了这些内容，我们将一律予以删除，请理解并监督我们。"},
                        {"item": "您使用华强方特图库网服务上传、发布或传输内容即代表了您有权且同意在全世界范围内，永久性的、不可撤销的、免费的授予华强方特图库网对该内容的存储、使用、发布、复制、发行、展览、网络传播、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示等权利；将内容的全部或部分编入其他任何形式的作品、媒体、技术中的权利；对您的上传、发布的内容进行商业开发的权利；通过有线或无线网络向计算机终端、移动通讯终端（包括但不限于便携式通讯设备如手机和智能平板电脑等）、手持数字影音播放设备、电视接收设备（模拟信号接收设备、数字信号接收设备、数字电视、IPTV、带互联网接入功能的播放设备等）等提供信息的下载、数据传输、及其相关的宣传和推广等服务的权利；再授权给其他第三方以上述方式使用的权利；以及对作品进行单独维权的权利。"},
                        
                    ]
                },
                {
                    "tittle":"4、用户使用声明",
                    "content":[
                        {"item":"华强方特图库网仅限于华强方特集团内部员工进行学习交流和资源共享等用途。网站内的资源仅用于集团相关宣传和推广用途，未经许可不得授予第三方使用。"},
                        {"item": "华强方特图库网作为网络服务提供者，对非法转载，盗版行为的发生不具备充分监控能力。【创意图片】栏目下下载的图片，请仔细阅读图片版权说明，了解其是否能用于商业用途，谨慎使用。"},
                    ]
                },
            ],
]
export default {
    data(){
        return {
            tittle:tittle,
            activedIndex:0,
             detail: true,
             list:list,
             img1:img1,
             isFirstChange: false,
        }
    },
     methods:{
         shoose:function(index){
            this.activedIndex=index;
            this.detail = false;
            this.$nextTick(()=>{
                  this.detail = true; 
                  this.isFirstChange = false;
            })
         },
       slide:function(event,index){
            let curTarget = event.currentTarget,
                    containsCurClass = curTarget.classList.contains("up"),
                    nextSibling = curTarget.nextSibling;
            while(nextSibling.nodeType == 3 && /\s/.test(nextSibling.nodeValue)){
                nextSibling = nextSibling.nextSibling;
            };
            let detailScrollHeight = nextSibling.scrollHeight;
            if(index==0 && !this.isFirstChange){
                nextSibling.style.height = detailScrollHeight + "px";
                this.isFirstChange = true;
            }
            setTimeout(()=>{
                if(containsCurClass){
                    curTarget.classList.remove("up");
                    this.toggleSlide(nextSibling,detailScrollHeight,'500');
                }else{
                    curTarget.classList.add("up");
                    this.toggleSlide(nextSibling,0,'500');
                }
            },10);
            
        },
        toggleSlide:function(dom,height,time){
            dom.style.transition = 'height ' + time + 'ms';
            dom.style.height = height + 'px';
        }
    }
    

}
</script>
<style scoped>
.content{
    width: 1280px;
    margin: 0 auto;
    position: relative;
    padding: 50px 0;
    min-height: 500px;

}
.right{
    width: 950px;
    border:1px solid #e7e7e7;
    border-radius: 10px;
    overflow: hidden;
}
.header{
 padding: 0 50px;
 font-size: 18px;
 background: #fff;
 cursor: pointer;
}
.right h4{
 line-height: 70px;
        border-bottom:none;


}
.right h4 span{
  float:right;
  width: 20px;
  height: 20px;
  background:url('../../assets/img/close_icon.png') no-repeat center;
  margin-top: 25px;

}
.right .up  h4 span{
  background:url('../../assets/img/open_icon.png') no-repeat center;

}
.right .up  h4 {
     border-bottom: 1px solid #e7e7e7;
}
.con .same_module:last-child h4
{
border: none;
}
.close_icon{
    display: block;
    padding-top:35px; 
}
.item{
 padding: 20px 50px;



}
.item li{
    font-size: 16px;
     line-height: 2;
     text-align: justify
}
.item img{
    width: 90%;
    display: block;
   padding: 20px 0;
   margin: 0 auto;

}
.detail{
    overflow: hidden;
}
.left{
    width: 180px;
    padding: 10px 0 ;
    position: absolute;
    right: 970px;
    top:50px;
}
.left ul{
    border:1px solid #e7e7e7;
    border-radius: 10px;
    background: #fff;
}
.left li{
    line-height: 2.4;
    text-align: center;
    margin: 10px;
    font-size: 18px;
    position: relative;
    color: #000;
    cursor: pointer;
}
.left li.actived{
    font-weight: bolder;
}
.left li.actived:after{
    width: 66px;
    height: 4px;
    content: "";
    background: #6aa9ff;
    position: absolute;
    bottom:0;
    left: 50%;
    margin-left: -33px;

}
 
.down-btn{
    display: block;
    margin-top: 20px;
    line-height: 40px;
    color: #999;
    text-align: center;
    border: 1px solid #ff9933;
    border-radius: 21px;
    cursor: pointer;
    transition: all .3s;
    user-select: none;
}
.down-btn:hover{
    background-color: #ff9933;
    color: #fff;
}
.explain{
    font-size: 12px;
    color: #999;
    text-align: center;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/help/help.vue